import { Component, Injector, Input, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ChargingStationDto } from '@dto/chargingStationDto';
import { ChargingstationGroupDto } from '@dto/chragingstationGroupDto';
import { UserDto } from '@dto/userDto';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UsersService } from '@services/entity/users.service';
import { ToastService } from '@services/toast/toast.service';
import { AbstractDialogContent } from '../../../../abstracts/dialog/dialog-content';
import { ChargingStationsService } from '../../../../services/entity/charging-stations.service';
import { FormService } from '../../../../services/form/form.service';

@Component({
  selector: 'app-create-groups',
  templateUrl: './create-groups.component.html',
  styleUrls: ['./create-groups.component.scss']
})
export class CreateGroupsComponent extends AbstractDialogContent implements OnInit {

  public className = 'CreateGroupsComponent';

  @Input() public customerId: number;

  public group: ChargingstationGroupDto = new ChargingstationGroupDto();
  public chargingstations: ChargingStationDto[];
  public assignedChargingStations: ChargingStationDto[] = [];
  public users: UserDto[];
  public formCreated: boolean = false;

  constructor(public activeModal: NgbActiveModal, public formService: FormService, injector: Injector,
    private chargingStationsService: ChargingStationsService,
    private usersService: UsersService,
    private toastService: ToastService
  ) {
    super(activeModal, injector);
  }

  ngOnInit(): void {
    this.loadChargingStations();
    this.loadUsers();
    this.createForm();
  }

  loadChargingStations() {
    if (this.customerId) {
      this.chargingStationsService.getChargingStationsOfCustomer(this.customerId).subscribe(result => {
        this.setupChargingStations(result);
      }, error => {});
    } else {
      this.chargingStationsService.getChargingStationsOfCurrentCustomer().subscribe(result => {
        this.setupChargingStations(result);
      }, error => {});
    }
  }

  loadUsers() {
    if (this.customerId) {
      this.usersService.getUsersOfCustomer(this.customerId).subscribe(result => {
        this.setupUsers(result);
      }, error => {});
    } else {
      this.usersService.getUsersOfCurrentCustomer().subscribe(result => {
        this.setupUsers(result);
      }, error => {});
    }
  }

  createForm() {
    this.formService.validators = {
      name: [Validators.required],
    }

    this.formService.form = new UntypedFormGroup({
      name: new UntypedFormControl(this.group.name, this.formService.validators['name']),
      description: new UntypedFormControl(this.group.description),
      selectedChargingstations: new UntypedFormControl(this.group.chargingStations),
      selectedUsers: new UntypedFormControl(this.group.users)
    });

    this.formCreated = true;
  }


  onSubmit(formValue) {
    this.toastService.loading($localize`:@@SavingChangesToast:Änderungen werden gespeichert.`)
    var chargingStationGroupDto: ChargingstationGroupDto = {
      name: formValue.name,
      description: formValue.description,
      chargingStations: formValue.selectedChargingstations,
      users: formValue.selectedUsers
    };
    

    if(this.customerId){
      this.chargingStationsService.createChargingStationGroupForCustomer(chargingStationGroupDto, this.customerId).subscribe(result => {
        this.toastService.success($localize`:@@SavingChangesErrorToast:Änderungen gespeichert`, 0, true);
        this.activeModal.close();
      }, error => {
        this.toastService.error(`:@@SavingChangesErrorToast:Änderungen konnten nicht gespeichert werden`, 0, true);
      });
    }
    else{
          this.chargingStationsService.createChargingStationGroupForCurrentCustomer(chargingStationGroupDto).subscribe(result => {
      this.toastService.success($localize`:@@SavingChangesErrorToast:Änderungen gespeichert`, 0, true);
      this.activeModal.close();
    }, error => {
      this.toastService.error(`:@@SavingChangesErrorToast:Änderungen konnten nicht gespeichert werden`, 0, true);
    });
    }

  }

  setupChargingStations(chargingstations : ChargingStationDto[]) {
    this.chargingstations = chargingstations
    this.chargingstations = this.chargingstations
      .sort((a, b) => a.name.localeCompare(b.name))
  }

  setupUsers(users: UserDto[]) {
    this.users = users
    this.users = this.users
      .sort((a, b) => a.fullName.localeCompare(b.fullName))
  }
}
